import { render, staticRenderFns } from "./CalendarMinusOutline.vue?vue&type=template&id=c4537772"
import script from "./CalendarMinusOutline.vue?vue&type=script&lang=js"
export * from "./CalendarMinusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports